// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  algolia: {
    appId: 'WVKAOWYTJX',
    searchAPIKey: '9f48e22a2537ceddaea9c64a49bec593',
    listingIndexName: 'screens',
  },
  firebase: {
    apiKey: 'AIzaSyCEnVfhK5KzhIdofinWud87EL_DLDyoA1k',
    authDomain: 'signgaze-dev.firebaseapp.com',
    databaseURL: 'https://signgaze-dev.firebaseio.com',
    projectId: 'signgaze-dev',
    storageBucket: 'signgaze-dev.appspot.com',
    messagingSenderId: '1080631111422',
    appId: '1:1080631111422:web:ec7bbcf0ea1637782dffaf',
    measurementId: 'G-B52FCLMR6Q',
  },
  resetPasswordURL: 'https://signgaze-dev.web.app/#/auth/email/action',
  originURL: 'https://signgaze-dev.web.app/#/',
  logrocket: 'bahrzn/signgaze-dev',
  datadog: {
    applicationId: 'e677d54f-c073-49ab-9cf2-f2e64b99ea0e',
    clientToken: 'pub6cd298f20a106d30d427fabf600e7848',
    site: 'datadoghq.com',
    service: 'signgaze',
    // version: '1.0.0',
    sampleRate: 100,
    env: 'dev',
    trackInteractions: true,
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
